import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermosPavEmbedComponent } from './termos-pav-embed.component';

/** Termos do paciente no pav, por cima do pré-atendimento. Sem fechar no Esc: perderia o termo em preenchimento. */
@Component({
  selector: 'app-termos-pav-modal',
  standalone: true,
  imports: [CommonModule, TermosPavEmbedComponent],
  template: `
    <div class="tp-fundo" role="dialog" aria-modal="true" aria-labelledby="tp-titulo">
      <div class="tp-janela">
        <div class="tp-topo">
          <span class="tp-icone" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="square">
              <path d="M14 3H6v18h7"/><path d="M14 3l5 5v5"/><path d="M14 3v5h5"/><circle cx="16.5" cy="17" r="2.6"/><path d="M18.5 19l2.5 2.5"/>
            </svg>
          </span>
          <h2 id="tp-titulo" class="tp-titulo">Termos do paciente</h2>
          <button type="button" class="tp-fechar" aria-label="Fechar" (click)="fechar.emit()">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
              <path d="M6 18 18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <app-termos-pav-embed class="tp-corpo" [cdPessoaFisica]="cdPessoaFisica"></app-termos-pav-embed>
      </div>
    </div>`,
  styles: [`
    .tp-fundo { position: fixed; inset: 0; z-index: 400; display: flex; align-items: center; justify-content: center;
                padding: 16px; background: rgba(11, 44, 69, .45); backdrop-filter: blur(4px); }
    .tp-janela { display: flex; flex-direction: column; width: min(1200px, 100%); height: min(92vh, 920px);
                 background: var(--flua-fundo); border: 1px solid var(--flua-borda); border-radius: 16px; overflow: hidden;
                 box-shadow: 0 24px 60px -20px rgba(16, 24, 32, .5); }
    .tp-topo { position: relative; display: flex; align-items: center; gap: 12px; padding: 12px 16px;
               background: var(--cartao); border-bottom: 1px solid var(--flua-borda); }
    .tp-topo::after { content: ""; position: absolute; left: 0; right: 0; bottom: -1px; height: 2px; background: var(--flua-linha); }
    .tp-icone { display: grid; place-items: center; width: 36px; height: 36px; border-radius: 10px;
                background: var(--marca-tint); color: var(--marca-acao); flex: none; }
    .tp-titulo { margin: 0; font-size: 16px; font-weight: 800; color: var(--tx); letter-spacing: -.01em; }
    .tp-fechar { margin-left: auto; display: grid; place-items: center; width: 34px; height: 34px; border-radius: 10px;
                 border: 1px solid var(--flua-borda); color: var(--tx-2); background: var(--cartao); }
    .tp-fechar:hover { background: var(--flua-rodape); color: var(--tx); }
    .tp-fechar:focus-visible { outline: 2px solid var(--marca-acao); outline-offset: 2px; }
    .tp-corpo { flex: 1; min-height: 0; }`],
})
export class TermosPavModalComponent {
  @Input({ required: true }) cdPessoaFisica!: string | number;
  @Output() fechar = new EventEmitter<void>();
}
